export default "__VITE_ASSET__osJCq$fr__"